import API from "./interceptor";

export const get = (url: string, config = {}) => API.get(url, config);
export const post = (url: string, data: any, config = {}) => API.post(url, data, config);
export const put = (url: string, data: any, config = {}) => API.put(url, data, config);
export const patch = (url: string, data: any, config = {}) => API.patch(url, data, config);
export const del = (url: string, config = {}) => API.delete(url, config);
